<template>
    <div>
        <p class="text-guide">
            {{ $t('paragraphs.syndication_tip1') }}<br>
            {{ $t('paragraphs.syndication_tip2', {count: syndication_enable_max_count}) }}
        </p>
        <div class="text-right mb-3"><button class="btn btn-primary" @click="openEditor()" v-if="(syndications.length < syndication_max_count) && syndicationAvailable">{{ $t('words.add') }}</button></div>
        <ul class="syndication__list">
            <li v-for="(syndication) in syndications" :id="`syndication_${syndication.id}`" :key="syndication.id">
                <h3 class="syndication__title">{{ syndication.title }}</h3>
                <div class="syndication__action">
                    <button class="btn btn-icon btn-flat" @click="openEditor(syndication)">
                        <i class="icon icon-edit"></i>
                    </button>
                    <button class="btn btn-icon btn-flat" @click="doDelete(syndication)" >
                        <i class="icon icon-trash"></i>
                    </button>
                    <toggle-button v-model="syndication.status" :sync="true" @change="changeStatus(syndication)"></toggle-button>
                </div>
                <dl class="row syndication__item">
                    <dt class="col-md-3">{{ $t('words.link') }}</dt>
                    <dd class="col-md-9">{{ syndication.link }}</dd>
                    <dt class="col-md-3">{{ $t('words.stream_key') }}</dt>
                    <dd class="col-md-9">{{ syndication.stream_name }}</dd>
                </dl>
            </li>
        </ul>
        <div class="modal fade" id="synEditorModal" tabindex="-1" role="dialog" aria-labelledby="editorModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="hideChannelModalLabel">{{ $t('words.syndication') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="title">{{ $t('words.title') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="title" maxlength="16" :class="{'form-control':true, 'is-invalid':meta.errors.title}" v-model="editor_title" />
                                <span class="invalid-feedback" v-if="meta.errors.title" v-for="error in meta.errors.title" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3">{{ $t('words.link') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="link" name="link" :class="{'form-control':true, 'is-invalid':meta.errors.link}"  v-model="editor_link" />
                                <span class="invalid-feedback" v-if="meta.errors.link" v-for="error in meta.errors.link" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3">{{ $t('words.stream_key') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="stream_key" name="stream_name" :class="{'form-control':true, 'is-invalid':meta.errors.stream_name}"  v-model="editor_stream_name" />
                                <span class="invalid-feedback" v-if="meta.errors.stream_name" v-for="error in meta.errors.stream_name" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3">{{ $t('words.use_yes_no') }}</label>
                            <div class="col-md-9">
                                <toggle-button :sync="true" v-model="editor_status" ></toggle-button>
                                <span class="invalid-feedback" v-if="meta.errors.status" v-for="error in meta.errors.status" :key="error">{{ error }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="ml-auto">
                            <button class="btn mr-2" @click="closeEditor()" >{{ $t('words.cancel') }}</button>
                            <button class="btn btn-primary" @click="doUpdate()" ><span v-if="isModify">{{ $t('words.edit') }}</span><span v-else>{{ $t('words.register') }}</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        channel: {
            type: [Object],
            require: true,
        },
    },
    data() {
        return {
            syndication_enable_max_count: 3,
            syndication_max_count: 10,
            meta: {
                errors: {
                },
            },
            syndications: {},
            editor_id: -1,
            editor_kind: '',
            editor_title: '',
            editor_link: 'rtmp://',
            editor_stream_name: '',
            editor_status: false,
        };
    },
    methods: {
        initialDatas() {
            this.loadSyndications();
        },
        loadSyndications() {
            const self = this;
            axios.get(this.syndicationApi).then((response) => {
                self.syndications = response.data.data;
                self.syndication_max_count = response.data.meta.syndication_max_count;
            }).catch((error) => {
                self.meta.errors = error.response.data.errors;
            });
        },
        initializeEditor() {
            this.meta.errors = {};
            this.editor_id = -1;
            this.editor_title = '';
            this.editor_link = 'rtmp://';
            this.editor_stream_name = '';
            this.editor_status = false;
        },
        openEditor(syndication = null) {
            if (syndication === null) {
                this.initializeEditor();
            } else {
                this.editor_id = syndication.id;
                this.editor_title = syndication.title;
                this.editor_link = syndication.link;
                this.editor_stream_name = syndication.stream_name;
                this.editor_status = syndication.status;
            }
            $('#synEditorModal').modal();
        },
        closeEditor() {
            this.initializeEditor();
            $('#synEditorModal').modal('hide');
        },
        doUpdate() {
            const self = this;
            const pickedData = {
                id: this.editor_id,
                title: this.editor_title,
                link: this.editor_link,
                stream_name: this.editor_stream_name,
                status: this.editor_status,
            };

            self.meta.errors = {};

            if (this.editor_id === -1) {
                axios.post(this.syndicationApi, pickedData).then((response) => {
                    self.syndications.push(response.data.data);
                    self.closeEditor();
                }).catch((error) => {
                    self.meta.errors = error.response.data.errors;
                    if (typeof error.response.data.errors === 'undefined' && typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                        this.$toasted.error(error.response.data.message);
                    } else {
                        self.$toasted.error(this.$t('paragraphs.message.error.create'));
                    }
                });
            } else {
                axios.put(`${this.syndicationApi}/${this.editor_id}`, pickedData).then((response) => {
                    self.loadSyndications();
                    self.closeEditor();
                }).catch((error) => {
                    self.meta.errors = error.response.data.errors;
                    if (typeof error.response.data.errors === 'undefined' && typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                        this.$toasted.error(error.response.data.message);
                    } else {
                        self.$toasted.error(this.$t('paragraphs.message.error.update'));
                    }
                });
            }
        },
        changeStatus(syndication) {
            const lSyndication = Object.create(syndication);
            axios.put(`${this.syndicationApi}/${lSyndication.id}/change_status`, { status: lSyndication.status }).then(() => {
                this.$toasted.success(this.$t('paragraphs.message.success.update'));
            }).catch((error) => {
                if (lSyndication.status) {
                    lSyndication.status = false;
                } else {
                    lSyndication.status = true;
                }
                if (typeof error.response.data.errors === 'undefined' && typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                    this.$toasted.error(error.response.data.message);
                }
            });
        },
        doDelete(syndication) {
            const lSyndication = Object.create(syndication);
            if (confirm(this.$t('paragraphs.message.confirm.remove_item'))) {
                axios.delete(`${this.syndicationApi}/${lSyndication.id}`)
                    .then((response) => {
                        this.loadSyndications();
                    })
                    .catch((error) => {
                        this.$toasted.error(this.$t('paragraphs.message.error.remove'));
                    });
            }
        },
        changeChannel(data) {
            this.$emit('changeChannel', data);
        },
    },
    computed: {
        ...mapGetters([
            'selectedServiceAccount',
            'selectedServiceAccountContract',
        ]),
        syndicationApi() {
            return '/cms/creator/syndications';
        },
        isModify() {
            return this.editor_id !== -1;
        },
        syndicationAvailable() {
            return this.selectedServiceAccount && !_.isEmpty(this.selectedServiceAccountContract) &&
                this.selectedServiceAccountContract.live_use_syndication;
        },
    },
    watch: {
        channel(newValue, oldValue) {
            if (typeof oldValue.id === 'undefined') {
                this.initialDatas();
            }
        },
        editor_kind(newValue, oldValue) {
            this.editor_app_name = this.syndication_kinds[newValue];
        },
    },
};

</script>
<style>
</style>
